import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import './MultipleChoiceAnswer.less';

export function MultipleChoiceAnswer({ question }) {
  const inputType = question.question_type === 'multiple-answer' ? 'checkbox' : 'radio';

  return (
    <ul className="multiple_choice_answer" role="group">
      {question.options.map((option) => {
        const html = option.option_text_as_html;

        return (
          <li key={`${question.question_id}_${option.sort_order}`}>
            <label htmlFor={`${question.question_id}_${option.sort_order}`} className="option_label">
              <Field>
                {({ field }) => {
                  let checked = false;

                  if (field.value.answer) {
                    if (inputType === 'checkbox') {
                      checked = field.value.answer.includes(option.sort_order.toString());
                    }

                    if (inputType === 'radio') {
                      checked = parseInt(field.value.answer) === option.sort_order;
                    }
                  }

                  return (
                    <input
                      {...field}
                      checked={checked}
                      id={`${question.question_id}_${option.sort_order}`}
                      name="answer"
                      type={inputType}
                      value={option.sort_order}
                    />
                  );
                }}
              </Field>
              {/* eslint-disable-next-line react/no-danger */}
              <span dangerouslySetInnerHTML={{ __html: html }} />
            </label>
          </li>
        );
      })}
    </ul>
  );
}

MultipleChoiceAnswer.propTypes = {
  question: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.object),
    question_id: PropTypes.number,
    question_type: PropTypes.oneOf(['multiple-answer', 'multiple-choice', 'yes-no']),
  }).isRequired,
};

export default MultipleChoiceAnswer;
